import React from "react";
import PointGuideState, { PointGuideProps } from "./PointGuide.models";
import './PointGuide.scss';
import PointsService from "../../../services/management/PointsService";
import { NavLink } from "react-router-dom";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import PointGuideModal from "../point-guide-modal/PointGuideModal";

export default class PointGuide extends React.PureComponent<PointGuideProps, PointGuideState>{
    pointsService: PointsService;

    constructor(props: any) {
        super(props);
        this.pointsService = new PointsService();
        this.state = { pointsGuide: { rows: [], totalRowCount: 0 }, pointId: 0, showModal: false };
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let self = this;

        self.pointsService.getActivePoints({
            orderField: "PointId",
            pageSize: 1000,
            pageSkip: 0,
            descendingOrder: true
        }).then(function (response) {
            self.setState({ pointsGuide: response });
        })
    }

    showPointDetail = (pointId: number) => {
        let self = this;
        self.setState({ pointId: pointId, showModal: true });
    }

    closeModal = () => {
        let self = this;
        self.setState({ showModal: false });
    }

    render(): React.ReactNode {
        let { pointsGuide, showModal, pointId } = this.state;
        let content;
        if (pointsGuide.rows.length > 0)
            content = (<div className="tk-aling-right point-guide-area tk-padding-top dropdown-list">
                {pointsGuide.rows.map((point, key) => {
                    return (
                        <div key={key} className="col-12 notspace margin-top box-shadow">
                            <div className="tk-inline card-boundel">
                                <div className="col-2 notspace">
                                    <div className="points success-images">
                                        <label className="mdi mdi-star star"></label>
                                    </div>
                                </div>
                                <div className="col-7 notspace" style={{ textAlign: "right", marginRight: " 20px" }}>
                                    <div className="pd-detail">
                                        <div className="course-title">
                                            <label>{point.pointTitle}</label>
                                        </div>
                                        <div className="course-subtitle">
                                            <label>{point.point} امتیاز</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3 notspace">
                                    <button className="show-info" style={{ outline: "none" }} onClick={() => this.showPointDetail(point.pointId)}>
                                        جزئیات
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>);
        else content = (<NotFoundDataInDate title="موردی جهت نمایش یافت نشد" />);

        let headerView = (<div className="about-headre point-guide-area">
            <div className="mt-2">
                <label className="page-title" style={{ color: "black" }}>راهنمای دریافت امتیاز</label>
                <NavLink to={"/Rewards?statusPage=2"}>
                    {/* mdi-light  */}
                    <span className="mdi mdi-arrow-left mdi-24px " ></span>
                </NavLink>
            </div>
        </div>);

        return (<>

            {content}

            <PointGuideModal closeModal={this.closeModal} showModal={showModal} pointId={pointId} />
        </>);
    }
}